// extracted by mini-css-extract-plugin
module.exports = {"description":"product-detail-and-shipping_description__qCpl9 pt-[20px] font-sans leading-[1.4] text-[#222]"};